export class HealthInsuranceNotIntegratedError extends Error {
  constructor() {
    super('Convênio médico não integrado')
    this.name = 'HealthInsuranceNotIntegratedError'
  }
}
